import i18n from "i18next";

type AuditCategories = {
  name: string;
  displayName: string;
  access: string;
};

type FieldChanges = {
  fieldName?: string;
  oldValue?: string | object | unknown[];
  newValue?: string | object | unknown[];
  fields?: Record<string, unknown>[];
  title?: string;
};

function activityLogNameMapper(
  categories: AuditCategories[]
): Omit<AuditCategories, "displayName">[] {
  return categories.map(({ displayName, ...rest }) => ({
    ...rest,
    name: i18n.t(`customRoles:CATEGORY_NAMES.${rest.name}`, {
      defaultValue: displayName,
    }),
  }));
}

export function customRoleNameMapper(fieldChanges: FieldChanges[]): void {
  for (const change of fieldChanges) {
    if (change.fieldName === "permissions") {
      if (Array.isArray(change.oldValue)) {
        change.oldValue = activityLogNameMapper(change.oldValue as AuditCategories[]);
      }
      if (Array.isArray(change.newValue)) {
        change.newValue = activityLogNameMapper(change.newValue as AuditCategories[]);
      }
    }
  }
}